var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListBullets = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 23,
  viewBox: "0 0 26 23",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.498,
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 2.498h15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 10.498,
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 10.498h15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 18.498,
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 18.498h15"
}))));
export { SvgListBullets as ReactComponent };
export default __webpack_public_path__ + "assets/images/list-bullets.svg";